document.addEventListener("DOMContentLoaded", function () {
  const scope = document.querySelector(".lpWrap");

  if (!scope) {
    console.warn("[LP] .lpWrap not found");
    return;
  }

  /* =========================
    Swiper存在チェック
  ========================= */
  if (!window.Swiper) {
    console.warn("[LP] Swiper not loaded");
  }

  function initSwiper(rootEl, options) {
    if (!window.Swiper) return;
    if (!rootEl) return;

    try {
      if (rootEl.swiper) rootEl.swiper.destroy(true, true);
      new Swiper(rootEl, options);
    } catch (e) {
      console.error("[LP] Swiper init failed:", rootEl, e);
    }
  }

  /* =========================
    REASON01
  ========================= */
  (function () {
    const root = scope.querySelector(".reason01 .swiper");
    if (!root) return;

    const paginationEl = root.querySelector(".swiper-pagination");
    const nextEl = root.querySelector(".swiper-button-next");
    const prevEl = root.querySelector(".swiper-button-prev");

    const opts = {
      loop: true,
      observer: true,
      observeParents: true,
    };

    if (paginationEl) {
      opts.pagination = { el: paginationEl, clickable: true };
    }

    if (nextEl && prevEl) {
      opts.navigation = { nextEl, prevEl };
    }

    initSwiper(root, opts);
  })();

  /* =========================
    自動再生 swiperauto
  ========================= */
  (function () {
    const roots = scope.querySelectorAll(".swiperauto");
    if (!roots.length) return;

    roots.forEach((root) => {
      initSwiper(root, {
        loop: true,
        autoplay: {
          delay: 8000,
          disableOnInteraction: false,
        },
        observer: true,
        observeParents: true,
      });
    });
  })();

  /* =========================
    kensho
  ========================= */
  (function () {
    const root = scope.querySelector(".researchSec .kenshoSwiper");
    if (!root) return;

    const paginationEl = root.querySelector(".swiper-pagination");

    const opts = {
      loop: false,
      centeredSlides: false,
      slidesPerView: 1.05,
      spaceBetween: 12,
      breakpoints: {
        768: {
          slidesPerView: 1.6,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 2.0,
          spaceBetween: 24,
        },
      },
      observer: true,
      observeParents: true,
    };

    if (paginationEl) {
      opts.pagination = { el: paginationEl, clickable: true };
    }

    initSwiper(root, opts);
  })();

  /* =========================
    voice
  ========================= */
  (function () {
    const root = scope.querySelector(".voiceSwiper");
    if (!root) return;

    const paginationEl = root.querySelector(".swiper-pagination");

    const opts = {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      observer: true,
      observeParents: true,
    };

    if (paginationEl) {
      opts.pagination = { el: paginationEl, clickable: true };
    }

    initSwiper(root, opts);
  })();

  /* =========================
    FAQ accordion
  ========================= */
  (function () {
    const qaArea = scope.querySelector("#qa_area");
    if (!qaArea) return;

    qaArea.querySelectorAll(".q-box").forEach((question) => {
      const answer = question.nextElementSibling;

      if (!answer || !answer.classList.contains("a-box")) return;

      question.classList.remove("on");
      answer.style.display = "none";

      question.addEventListener("click", function () {
        const isOpen = question.classList.contains("on");

        question.classList.toggle("on", !isOpen);
        answer.style.display = isOpen ? "none" : "block";
      });
    });
  })();

  /* =========================
    旧アコーディオン accordion_q
  ========================= */
  (function () {
    scope.querySelectorAll(".accordion_q").forEach((header) => {
      header.addEventListener("click", function () {
        const content = header.nextElementSibling;
        if (!content) return;

        const isOpen = content.style.display === "block";
        content.style.display = isOpen ? "none" : "block";
        header.classList.toggle("arrow", !isOpen);
      });
    });
  })();

  /* =========================
    アコーディオン：詳しく見る
  ========================= */
  (function () {
    scope.querySelectorAll(".accordion-header").forEach((header) => {
      header.addEventListener("click", function () {
        const content = header.nextElementSibling;
        if (!content) return;

        const icon = header.querySelector(".accordion-toggle");
        const isOpen = content.style.display === "block";

        content.style.display = isOpen ? "none" : "block";

        if (icon && icon.tagName === "IMG") {
          icon.src = isOpen
            ? "https://cdn.shopify.com/s/files/1/0508/5347/8562/files/seedetails_btn_under.png"
            : "https://cdn.shopify.com/s/files/1/0508/5347/8562/files/seedetails_btn_top.png";

          icon.classList.toggle("open", !isOpen);
        }
      });
    });
  })();

  /* =========================
    アコーディオン：注意事項
  ========================= */
  (function () {
    scope.querySelectorAll(".accordion-header2").forEach((header) => {
      header.addEventListener("click", function () {
        const content = header.nextElementSibling;
        if (!content) return;

        const icon = header.querySelector(".accordion-toggle");
        const isOpen = content.style.display === "block";

        content.style.display = isOpen ? "none" : "block";

        if (icon && icon.tagName === "IMG") {
          icon.src = isOpen
            ? "https://cdn.shopify.com/s/files/1/0508/5347/8562/files/precautions_btn_under.png"
            : "https://cdn.shopify.com/s/files/1/0508/5347/8562/files/precautions_btn_top.png";

          icon.classList.toggle("open", !isOpen);
        }
      });
    });
  })();

  /* =========================
    固定ボタン
  ========================= */
  (function () {
    const fixBtn = scope.querySelector(".fixBtn");
    if (!fixBtn) return;

    window.addEventListener("scroll", function () {
      const y = window.scrollY || window.pageYOffset;

      if (y > 3000) {
        fixBtn.style.display = "block";
      } else {
        fixBtn.style.display = "none";
      }
    });
  })();

  /* =========================
    #TeamMueller modal
  ========================= */
  (function () {
    const modal = scope.querySelector("#teamModal");
    const openBtn = scope.querySelector("#openTeamMueller");

    if (!modal || !openBtn) return;

    const closeBtn = modal.querySelector(".tmClose");
    const overlay = modal.querySelector(".tmOverlay");

    function openModal() {
      modal.setAttribute("aria-hidden", "false");
      document.body.classList.add("tmOpen");
    }

    function closeModal() {
      modal.setAttribute("aria-hidden", "true");
      document.body.classList.remove("tmOpen");
    }

    openBtn.addEventListener("click", openModal);

    if (closeBtn) {
      closeBtn.addEventListener("click", closeModal);
    }

    if (overlay) {
      overlay.addEventListener("click", closeModal);
    }

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && modal.getAttribute("aria-hidden") === "false") {
        closeModal();
      }
    });
  })();
});